module.exports = __webpack_public_path__ + "components/wind-icon/static/NE@2x-7b82d1c027a65bf3451b7bc39910939c.png";